import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {MenuItemType} from '@models/sidebar/menu-item-type';
import {LeftMenuService} from '@services/left-menu/left-menu.service';
import {PageItem} from '@models/sidebar/page-item';
import {take} from 'rxjs/operators';
import {Subscription} from 'rxjs';

@Component({
    selector: 'scitis-edit-node-inline-form',
    templateUrl: './edit-node-inline-form.component.html',
    styleUrls: ['./edit-node-inline-form.component.scss'],
    standalone: false
})
export class EditNodeInlineFormComponent implements OnInit {

  @Input()
  nodeItem: PageItem | undefined;

  @Input()
  userMenuItems: PageItem[] = [];

  @Output()
  newNodeSave: EventEmitter<PageItem> = new EventEmitter<PageItem>();

  @Output()
  newNodeCancel: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  propertiesFallback: EventEmitter<Object> = new EventEmitter<Object>();

  addNodeForm: UntypedFormGroup = this.fb.group({});
  enteredName: string = '';
  isNewPage: boolean = false;
  submitted: boolean = false;
  subscription: Subscription = new Subscription();
  propertiesFallbackObject = {
    name:'',
    url:''
  };

  constructor(private fb: UntypedFormBuilder, private leftMenuService: LeftMenuService) {
  }

  ngOnInit(): void {
    if (!this.nodeItem) {
      this.isNewPage = true;
    }
    this.enteredName = 'New node';
    this.generateAddNodeForm(this.nodeItem);
  }

  get hasDuplicates() {
    const valueFromInputField = this.addNodeForm.value.nodeName;
    const tabValue = this.nodeItem?.name;
    if (valueFromInputField && this.userMenuItems) {
      return this.leftMenuService.checkIfElementExistsByName(valueFromInputField, this.userMenuItems, tabValue);
    } else {
      return false;
    }
  }

  get isSavePageButtonDisabled(): boolean {
    return this.submitted ? this.addNodeForm.invalid : this.submitted && this.addNodeForm.invalid;
  }

  onSaveNode(): void {
    this.submitted = true;
    const currentName = this.nodeItem?.name;
    if (this.addNodeForm.valid) {
      if (!this.nodeItem) {
        this.nodeItem = new PageItem();
      }
      this.nodeItem.name = this.addNodeForm.controls.nodeName.value;
      this.nodeItem.type = MenuItemType.NODE;
      this.propertiesFallbackObject.name = currentName ? currentName : '' ;
      this.propertiesFallback.emit(this.propertiesFallbackObject);
      this.newNodeSave.emit(this.nodeItem);
      this.subscribeToItemNameChanges();
    }
  }

  onCancelSaveNode(): void {
    this.newNodeCancel.emit();
  }

  onUpdateName(): void {
    this.enteredName = this.addNodeForm.controls.nodeName.value;
  }

  private generateAddNodeForm(userMenuItem: PageItem | undefined): void {
    this.addNodeForm = this.fb.group({
      nodeName: [userMenuItem?.name ? userMenuItem?.name : '', [Validators.required]],
    });
  }

  private subscribeToItemNameChanges() {
    this.subscription = this.leftMenuService.errorUpdatePageChange.pipe(take(2))
    .subscribe((prevName: any) => {
      if (this.nodeItem && prevName) {
        this.nodeItem.name = prevName.name;
      }
    });
  }
}
